<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="projectTitle">Acessos do usuário {{ user.name }}</h5>
    <button type="button" class="close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows style="width: 100%;">
        <!-- created_at Column -->
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef> Acesso em </th>
          <td mat-cell *matCellDef="let element">{{element.created_at}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator
      fxLayoutAlign="end end"
      [length]="page.totalElements"
      [pageSize]="page.per_page"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="page.current_page"
      showFirstLastButtons
      (page)="pageEvent = getUsersAccess($event)"
    ></mat-paginator>
  </div>
</div>
